// extracted by mini-css-extract-plugin
export var barContainer = "_51-0";
export var extraThin = "_51-3";
export var fillBar = "_51-6";
export var fillContainer = "_51-4";
export var overflow = "_51-8";
export var overflowContainer = "_51-5";
export var regular = "_51-7";
export var thick = "_51-1";
export var thin = "_51-2";